import { render, staticRenderFns } from "./SignIndex.vue?vue&type=template&id=063fbd13&scoped=true&"
import script from "./SignIndex.vue?vue&type=script&lang=ts&"
export * from "./SignIndex.vue?vue&type=script&lang=ts&"
import style0 from "./SignIndex.vue?vue&type=style&index=0&id=063fbd13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fbd13",
  null
  
)

export default component.exports